import React from 'react';

export const SearchIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.9993 12.4243L10.4993 8.9495C11.1244 8.0248 11.4996 6.9244 11.4996 5.7498C11.4996 2.5746 8.9243 0 5.7498 0C2.5753 0 0 2.5753 0 5.7498C0 8.9243 2.5753 11.4996 5.7498 11.4996C6.9496 11.4996 8.05 11.1496 8.9495 10.5245L12.4243 13.9993L13.9993 12.4243ZM1.5246 5.7491C1.5246 3.4244 3.3999 1.5491 5.7246 1.5491C8.0493 1.5491 9.9498 3.4244 9.9498 5.7491C9.9498 8.0738 8.0745 9.9491 5.7498 9.9491C3.4251 9.9491 1.5246 8.0738 1.5246 5.7491Z"
        fill="white"
      />
    </svg>
  );
};
